import { mapZipcodeToState } from '@dashboard-experience/utils';

/**
 * Maps a zipcode to a state name string
 * @param zipcode The zipcode to map to a state
 * @returns The state name or '-' if not found
 */

export const getStateNameFromZipcode = (
  zipcode: string | null | undefined,
): string => {
  try {
    return mapZipcodeToState(zipcode).state_name || '-';
  } catch (error) {
    return '-';
  }
};
